import { render, staticRenderFns } from "./QuestionTimerDisplay.vue?vue&type=template&id=b80d5322&scoped=true&"
import script from "./QuestionTimerDisplay.vue?vue&type=script&lang=js&"
export * from "./QuestionTimerDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTimerDisplay.vue?vue&type=style&index=0&id=b80d5322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80d5322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
